export default {
  name: 'support-console',
  translationKey: 'support-console-module',
  routePrefix: 'support-console',
  routeNamePrefix: 'admin.support-console',
  directRoutesAvailable: false,
}
